import { render, staticRenderFns } from "./SidebarCpt.vue?vue&type=template&id=2513e2dc&scoped=true&"
import script from "./SidebarCpt.vue?vue&type=script&lang=ts&"
export * from "./SidebarCpt.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCpt.vue?vue&type=style&index=0&id=2513e2dc&scoped=true&lang=scss&"
import style1 from "./SidebarCpt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513e2dc",
  null
  
)

export default component.exports